"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Policy_1 = require("./Policy");
class MatureRestCountryPolicy extends Policy_1.Policy {
    constructor() {
        super(...arguments);
        this.countries = [
            22, 44, 202, 100, 4, 103, 5, 6, 204, 9, 10, 205, 25, 107, 13,
            14, 43, 112, 15, 113, 118, 47, 34, 35, 36, 1, 212, 214,
            19, 21, 131, 22, 48, 132, 133, 117, 24, 26, 136, 140, 30
        ];
    }
    meets(criteria) {
        return this.countries.includes(criteria.countryId);
    }
}
exports.default = new MatureRestCountryPolicy();
